import { ChangeDetectorRef, Component, EventEmitter, inject, Inject, Input, Optional, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { Observable, Observer, Subject } from 'rxjs';
import { DynamicFieldModel, Option } from '@share';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { DyanmicFormImgComponent } from '../dyanmic-form-img/dyanmic-form-img.component';
import { HttpClient, HttpParams } from '@angular/common/http';
// import { AutoFocusDirective } from '@delon/abc/auto-focus';
import { NzFormatEmitEvent, NzTreeComponent, NzTreeModule, NzTreeNode } from 'ng-zorro-antd/tree';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { environment } from 'src/environments/environment';
import { DyanmicFormImgFileComponent } from '../dyanmic-form-img-file/dyanmic-form-img-file.component';
import { LoadingService } from '../services/loading.service';
import { error } from '@ant-design/icons-angular';
import { RichTextEditorComponent } from '../rich-text-editor/rich-text-editor.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { FormsModule, } from '@angular/forms';

//import { validatorMap } from '../validators/validatormap';

const apiurl = environment.apiUrl;
@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzButtonModule,
    NzRadioModule,
    NzUploadModule,
    NzIconModule,
    NzCardModule,
    DyanmicFormImgComponent,
    DyanmicFormImgFileComponent,
    // AutoFocusDirective,
    NzTreeModule,
    NzInputNumberModule,
    RichTextEditorComponent,
    NzDatePickerModule,
    FormsModule,
    QuillModule
  ],
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent {
  @ViewChild('nzTreeComponent', { static: false }) nzTreeComponent: NzTreeComponent;
  private http = inject(HttpClient);
  @Input() fields: DynamicFieldModel[] = [];
  @Input() data: any;
  form: FormGroup;
  loading = false;
  imageUrl?: string;
  isFromModal: Boolean = false;
  filteredOptions: any = {};
  expandedKeys: any[] = [];
  groupValidators: ValidatorFn[] = [];
  modules = {
    toolbar: false,
    clipboard: {
      matchVisual: true
    }
  };

  formats = [
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'header', 'list', 'indent', 'link', 'image',
    'color', 'background', 'align', 'code-block'
  ];
  disablePastDateTime = (current: Date): boolean => {
    if (!current) return false;

    const now = new Date();
    // Remove seconds and milliseconds
    now.setSeconds(0, 0);

    return current.getTime() <= now.getTime();
  };
  @Output() onSubmitClicked = new EventEmitter<FormData>();

  constructor(private readonly fb: FormBuilder, @Optional() @Inject(NZ_MODAL_DATA) public modal_param: any, private readonly cdr: ChangeDetectorRef, private readonly loadingService: LoadingService) {
    if (modal_param && modal_param.fields.length > 0) {
      this.isFromModal = true;
      this.fields = modal_param.fields;
      this.data = modal_param?.data;
    }
    this.form = this.fb.group({});
  }

  ngOnInit() {
    this.createFormControls();

    // Watch for status changes to trigger scheduled_date validation
    const statusControl = this.form.get('status');
    const scheduledDateControl = this.form.get('scheduled_date');

    if (statusControl && scheduledDateControl) {
      statusControl.valueChanges.subscribe(value => {
        // Force scheduled_date to re-evaluate its validator
        scheduledDateControl.updateValueAndValidity();
      });
    }

    if (this.data) {
      this.form.patchValue(this.data, { emitEvent: true });

      //  Add this block to fix dependent selects in edit mode
      this.fields.forEach(field => {
        if (field.dependOn && field.optionUrl) {
          this.loadDependentOptions(field);
        }
      });
    }

    this.fields.forEach((field) => {
      if (field.dependOn && field.optionUrl) {
        const dependFields = Array.isArray(field.dependOn) ? field.dependOn : [field.dependOn];

        dependFields.forEach(depField => {
          this.form.get(depField)?.valueChanges.subscribe(x => {
            this.loadDependentOptions(field); // call helper


            // if (x && x.length > 0) {
            //   this.loadingService.showLoading();
            //   this.cdr.detectChanges();
            //   const queryParams = `${x}?name=${x}&id=${x}`;
            //   this.http.get<Array<Option>>(`${apiurl}/${field.optionUrl}/${queryParams}`).subscribe({
            //     next: y => {
            //       if (!y.some(val => val.value === this.form.get(field.name)?.value)) {
            //         this.form.get(field.name)?.patchValue(null);
            //       }
            //       this.filteredOptions[field.name] = y;
            //       this.loadingService.hideLoading();
            //       this.cdr.detectChanges();
            //     },
            //     error: err => {
            //       console.error('Error loading options:', err);
            //       this.loadingService.hideLoading();
            //       this.cdr.detectChanges();
            //     },
            //     complete: () => {
            //       this.loadingService.hideLoading();
            //       this.cdr.detectChanges();
            //     }
            //   });

            // const queryParams = `${x}?name=${x}&id=${x}`;
            // this.http.get<Array<Option>>(`${apiurl}/${field.optionUrl}/${queryParams}`).subscribe(y => {
            //   if (!y.some(val => val.value === this.form.get(field.name)?.value)) {
            //     this.form.get(field.name)?.patchValue(null);
            //   }
            //   this.filteredOptions[field.name] = y;
            // });
            // }
            // else {
            //   this.form.get(field.name)?.patchValue(null);
            //   this.loadingService.hideLoading();
            //   this.cdr.detectChanges();
            // }
          });
        });

        if (field?.hideByField !== undefined && field?.hideByFieldValue !== undefined) {
          this.shouldHide(field)
        }
      }
    });
    // if (this.data) {
    //   this.form.patchValue(this.data, { emitEvent: true });
    //   // Object.keys(this.data).forEach(key => {
    //   //   const control = this.form.get(key);
    //   //   if (control) {
    //   //     control.setValue(control.value, { emitEvent: true }); // 👈 Ensures valueChanges fires
    //   //   }
    //   // });
    // }

    if (this.groupValidators.length) {
      this.form.setValidators(Validators.compose(this.groupValidators));
    }




  }

  createFormControls(): void {
    this.fields.forEach((field) => {
      const control = this.fb.control(
        field.value || '',
        this.getValidators(field)
      );
      this.form.addControl(field.name, control);
      if (field.dependOn) {
        this.filteredOptions[field.name] = field.options;
      }
      // Group-level validators
      // if (field.groupValidators) {
      //   for (const v of field.groupValidators) {
      //     const factory = validatorMap[v.validator];
      //     if (factory) {
      //       this.groupValidators.push(factory(v.fields));
      //     }
      //   }
      // }
    });

  }

  getValidators(field: DynamicFieldModel): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (field.validations) {
      field.validations.forEach((validation: any) => {
        if (validation.validator === Validators.required) {
          validators.push(Validators.required);
        } else if (validation.validator === Validators.email) {
          validators.push(Validators.email);
        } else if (validation.name === 'phoneValid' && validation.validator === 'phoneValidator') {
          validators.push(this.phoneValidator());
        }
        else if (validation.name === 'requiredIf') {
          validators.push(validation.validator);
        }
        else if (validation.name === 'dateRange') {
          validators.push(validation.validator);
        }
        // Add more custom validators as needed
      });
    }
    return validators;
  }

  phoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const phoneRegex = /^(?:\+?95|0)9\d{6,9}$/;
      const valid = phoneRegex.test(control.value);
      return valid ? null : { phoneValid: true };
    };
  }

  onSubmit(): void {
    console.log(this.form.value);
    this.updateValidity();

    if (!this.form.valid) return;
    const formData = new FormData();

    Object.keys(this.form.value).forEach(key => {
      const value = this.form.value[key];

      if (key === 'images' && Array.isArray(value)) {
        value.forEach(file => formData.append('images', file));
      } else {
        formData.append(key, value);
      }
    });
    this.onSubmitClicked.emit(formData);
  }

  updateValidity() {
    Object.keys(this.form.controls).forEach(controlName => {
      const control = this.form.get(controlName);
      if (control) {
        control.markAsDirty();
        control.updateValueAndValidity();  // This will re-evaluate and update the validity of the control
      }
    });
  }

  getErrorTpl(field: DynamicFieldModel): string {
    const control = this.form.get(field.name);
    if (control && control.errors) {
      for (const validation of field.validations || []) {
        if (control.hasError(validation.name)) {
          return validation.message;
        }
      }
    }
    return '';
  }
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
    new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        //this.messageService.error('You can only upload JPG file!');
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        //this.messageService.error('Image must smaller than 2MB!');
        observer.complete();
        return;
      }
      //observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    const fileUrl = URL.createObjectURL(img);
    console.log(fileUrl);
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  // handleChange($event: Event){
  //   $event.preventDefault();
  //   const file = ($event?.target as HTMLInputElement).files[0];
  //   this.form.controls['image'].setValue(file);
  //   this.handleChangeNZUpload($event as any);
  // }

  handleChange(info: { file: NzUploadFile }): void {
    const file = info.file; // Get uploaded file

    // if (file.originFileObj) {
    //   this.form.controls['image'].setValue(file.originFileObj);
    //   console.log('Native File Object:', file.originFileObj);
    // }
    // this.form.controls['image'].setValue(info.file.url);
    // console.log(JSON.stringify(info.file))
    // switch (info.file.status) {
    //   case 'uploading':
    //     this.loading = true;
    //     break;
    //   case 'done':
    //     // Get this url from response in real world.
    //     this.getBase64(info.file!.originFileObj!, (img: string) => {
    //       console.log('enter');
    //       this.loading = false;
    //       this.imageUrl = img;
    //     });
    //     break;
    //   case 'error':
    //     //this.messageService.error('Network error');
    //     this.loading = false;
    //     break;
    // }

    this.getBase64(info.file!.originFileObj!, (img: string) => {
      this.loading = false;
      this.imageUrl = img;
      this.form.controls['image'].setValue(img);
    });
  }

  getImageUrl(controlName: string): string | null {
    return this.form.get(controlName)?.value || null;
  }

  filterSelectedValues(controlName: string) {
    const listOfSelectedValue = [...this.form.get(controlName)?.value];

    if (Array.isArray(listOfSelectedValue)) {
      const filteredValues = listOfSelectedValue.filter(item => item !== 'value1');
      console.log(filteredValues);
    } else {
      console.error('selectedValues is not an array');
    }
  }

  // depend on feature
  getFieldOptions(field: DynamicFieldModel) {
    return field.dependOn ? this.filteredOptions[field.name] : field.options;
  }

  // onFieldChange(fieldName: string, value: string) {
  //   if (this.fields.find(f => f.name === fieldName)?.dependOn) {
  //     this.form.get(fieldName)?.setValue(value);
  //   }
  // }

  nzCheck(event: NzFormatEmitEvent, controlName: string): void {
    console.log(controlName);
    let keys = event.checkedKeys.map(x => x.key);
    console.log(keys);
    let selectedKeys = this.getAllSelectedChildKeys();
    selectedKeys = [...selectedKeys, ...keys];
    this.form.get(controlName).setValue([...new Set(selectedKeys)]);
  }
  getAllSelectedChildKeys(): string[] {
    if (this.nzTreeComponent) {
      const checkedNodes = this.nzTreeComponent.getCheckedNodeList();
      let selectedKeys: string[] = [];

      checkedNodes.forEach(node => {
        this.getChildKeys(node, selectedKeys); // Collect child keys recursively
      });

      console.log('Selected Child Keys:', selectedKeys);
      return selectedKeys;
    }
    return [];
  }

  getChildKeys(node: NzTreeNode, selectedKeys: string[]): void {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        selectedKeys.push(child.key);
        this.getChildKeys(child, selectedKeys); // Recursively get all child keys
      });
    }
  }

  getReadonly(field: DynamicFieldModel): boolean {
    if (this.data) {
      return field.readonly || field.disableOnUpdate || false;
    }
    else {
      return field.readonly || false;
    }

  }

  shouldHide(field: DynamicFieldModel): boolean {
    // console.log(field);
    // if (field?.hideByField && field.hideByFieldValue && this.form.controls[field.hideByField].value && this.form.controls[field.hideByField].value === field.hideByFieldValue) {
    //   return true;
    // }
    // return false;
    if (!field?.hideByField || field.hideByFieldValue === undefined) {
      return true;
    }

    const control = this.form.get(field.hideByField);
    if (!control) return true;

    const hideValues = field.hideByFieldValue.split(',');
    return !hideValues.includes(control.value);
  }
  private loadDependentOptions(field: DynamicFieldModel) {
    // Identify Primary Parent (ID for the URL)
    const parentControlName = Array.isArray(field.dependOn) ? field.dependOn[0] : field.dependOn;
    const parentControl = this.form.get(parentControlName);
    const parentId = parentControl?.value;

    // Clear current field if no parent is selected
    if (!parentId) {
      this.filteredOptions[field.name] = [];
      this.form.get(field.name)?.patchValue(null);
      this.form.get('type')?.patchValue(null); // Clear the type field as well
      this.cdr.detectChanges();
      return;
    }

    let params = new HttpParams();
    if (Array.isArray(field.dependOn) && field.dependOn.length > 1) {
      const typeValue = this.form.get(field.dependOn[1])?.value;
      if (typeValue) {
        params = params.set('type', typeValue);
      }
    } else {
      const typeValue = field.matchType || this.form.get('type')?.value;
      if (typeValue) {
        params = params.set('type', typeValue);
      }
    }

    this.loadingService.showLoading();
    const url = `${apiurl}/${field.optionUrl}/${parentId}`;

    // Pass the { params } object to the get request
    this.http.get<any[]>(url, { params }).subscribe({
      next: (data) => {
        const mappedData = (data || []).map(item => ({
          text: item.name || item.text || item.maincategory_name,
          value: item.id || item.value,
          type: item.type
        }));

        if (field.matchType) {
          this.filteredOptions[field.name] = mappedData.filter(
            (item: any) => item.type === field.matchType
          );
        } else {
          this.filteredOptions[field.name] = mappedData;
        }

        const currentValue = this.form.get(field.name)?.value;
        const valueExists = this.filteredOptions[field.name].some(
          (o: any) => o.value === currentValue
        );

        if (currentValue && !valueExists) {
          this.form.get(field.name)?.patchValue(null);
        }
      },
      error: (err) => {
        console.error(`Error loading options:`, err);
        this.filteredOptions[field.name] = [];
        this.loadingService.hideLoading();
      },
      complete: () => {
        this.loadingService.hideLoading();
        this.cdr.detectChanges();
      }
    });
  }
}
